<template>
  <div>
    <b-field
      custom-class="z-u-text-label mt-4"
      type="is-danger"
      :message="validationMessage"
    >
      <template #label>
        <span class="label-title m-0">{{ labelText }}</span>
        <slot name="helper-text"></slot>
      </template>
      <template v-if="customErrorMessage && validationMessage.length > 0" #message>
        <span v-if="validationMessage[0]" class="por-input-error-text">
          {{ validationMessage[0] }}
          <slot name="error-info-text"></slot>
        </span>
      </template>
      <div data-hj-suppress>
        <vue-tel-input
          ref="vueTelInput"
          v-model="phoneNumber"
          :all-countries="allCountries"
          :class="`VueTelInput input mt-1 qa-phone-input ${
            $refs.vueTelInput && $refs.vueTelInput.phoneObject.valid
              ? ''
              : phoneNumber && hasBlurred
              ? 'is-danger'
              : ''
          }`"
          :default-country="preferredCountries[0]"
          :auto-format="false"
          mode="international"
          :input-options="inputOptions"
          :dropdown-options="dropdownOptions"
          :preferred-countries="preferredCountries"
          :valid-characters-only="true"
          @input="onInput"
          @blur="updateValidation"
          @validate="onValidationChange"
          :data-qa="dataQa"
        >
          <template #arrow-icon>
            <svg class="vti__dropdownIcon"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M15.875 9.00001L11.995 12.88L8.11501 9.00001C7.92817 8.81275 7.67452 8.70752 7.41001 8.70752C7.14549 8.70752 6.89184 8.81275 6.70501 9.00001C6.31501 9.39001 6.31501 10.02 6.70501 10.41L11.295 15C11.685 15.39 12.315 15.39 12.705 15L17.295 10.41C17.685 10.02 17.685 9.39001 17.295 9.00001C16.905 8.62001 16.265 8.61001 15.875 9.00001Z"
              />
            </svg>
          </template>
        </vue-tel-input>
      </div>
    </b-field>
  </div>
</template>

<script>
import { VueTelInput } from 'vue-tel-input'
import { mapGetters } from 'vuex'
import 'vue-tel-input/dist/vue-tel-input.css'
import countriesInGerman from './countries-in-german.json'
import countriesInFrench from './countries-in-french.json'
import countriesInSpanish from './countries-in-spanish.json'

export default {
  components: {
    VueTelInput
  },
  props: {
    value: {
      type: String,
      required: true
    },
    labelText: {
      type: String,
      required: true
    },
    dataQa: {
      type: String,
      default: ''
    },
    customErrorMessage: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      inputOptions: {
        showDialCode: false,
        name: 'address-phone'
      },
      dropdownOptions: {
        showFlags: true,
        showSearchBox: true,
        showDialCodeInList: true,
        showDialCodeInSelection: true,
        tabindex: 0
      },
      phoneNumber: '',
      phoneObject: {},
      validationMessage: '',
      hasBlurred: false
    }
  },
  computed: {
    allCountries () {
      switch (this.pseudoLocale) {
        case 'en_GB':
        case 'sd_SD':
        case 'as_AS':
        case 'en_IE':
        case 'sd_IE':
          return undefined
        case 'de_DE':
          return countriesInGerman
        case 'fr_FR':
          return countriesInFrench
        case 'es_ES':
          return countriesInSpanish
        default:
          return undefined
      }
    },
    preferredCountries () {
      switch (this.pseudoLocale) {
        case 'en_GB':
        case 'sd_SD':
        case 'as_AS':
          return ['gb']
        case 'de_DE':
          return ['de']
        case 'fr_FR':
          return ['fr']
        case 'en_IE':
        case 'sd_IE':
          return ['ie']
        case 'es_ES':
          return ['es']
        case 'it_IT':
          return ['it']
        default:
          return ['']
      }
    },
    ...mapGetters({
      pseudoLocale: 'site/language'
    })
  },
  mounted () {
    this.$refs.vueTelInput.phone = this.$props.value
    this.onInput(this.$props.value, this.$refs.vueTelInput.phoneObject)
  },
  watch: {
    phoneNumber (newVal) {
      if (newVal === '') {
        this.validationMessage = ''
        this.$emit('isValid', true)
      }
    }
  },
  methods: {
    onInput (event, phoneObject) {
      this.$emit(
        'input',
        phoneObject && phoneObject.number ? '' + phoneObject.number : event
      )
      if (phoneObject.valid) {
        this.$emit('isValid', phoneObject && phoneObject.valid)
        this.clearMessage()
      }
    },
    clearMessage () {
      this.validationMessage = ''
    },
    updateValidation () {
      this.hasBlurred = true

      if (this.phoneNumber !== '') {
        const message = this.customErrorMessage ? this.$t('common_invalidMobile_text') : this.$t('common_validMobile_text')
        this.validationMessage = [
          this.$refs.vueTelInput && this.$refs.vueTelInput.phoneObject && this.$refs.vueTelInput.phoneObject.valid
            ? ''
            : message
        ]
      }
    },
    onValidationChange (newVal) {
      this.$emit('isValid', newVal && newVal.valid)
    }
  }
}
</script>

<style lang="scss">
.VueTelInput {
  .vti__input:not(.vti__search_box) {
    border-radius: 0 7px 7px 0;
    font-size: 18px;
    height: -webkit-fill-available;
  }

  .vti__dropdown {
    .vti__search_box {
      font-size: 16px;
      width: -webkit-fill-available;
      border: none;
      position: sticky;
      top: 0;
      border-bottom: 1px solid #d0cfcb;
      border-radius: 0;
      margin: 0;
    }

    background-color: #f3f3f3;
    border-radius: 7px 0 0 7px;
    border: none !important;
    box-shadow: none !important;
    height: 100%;
    outline: none !important;
    padding-top: 0;
    padding-bottom: 0;
    padding-right: 5px;
    width: fit-content;

    .vti__dropdownIcon {
      fill: #1064F4;
      &:hover {
        fill: #363636;
      }
    }
  }

  .vti__dropdown:focus {
    border: 1px solid #0f62f4;
    box-shadow: 0 0 0 1px #0f62f4;
    border-right: none !important;
  }

  .vti__selection {
    width: fit-content;
  }

  .vti__dropdown-list.above {
    top: -218px;
  }

  .vti__dropdown-list.below {
    top: 56px;
  }

  .vti__country-code {
    font-size: 16px;
  }

  .vti__dropdown-list {
    border-radius: 8px;
    box-shadow: 0 49px 10px -20px rgba(0, 0, 0, 0.15) inset,
      0 -17px 10px -20px rgba(0, 0, 0, 0.15) inset;
    height: 205px;
    line-height: 20px;
    max-height: initial;

    .vti__flag-wrapper {
      display: flex;
      margin-right: 7px;
      width: 31px;

      .vti__flag {
        margin-left: 5px;
      }
    }

    .vti__dropdown-item {
      align-items: center;
      display: flex;
      height: auto;
      padding: 8px;

      strong {
        margin-right: 5px;
        padding-bottom: 1px;
      }

      span {
        margin-left: auto;
        padding-right: 16px;
      }
    }
  }

  &.is-danger {
    .vti__input:not(:focus, .vti__search_box) {
      background-color: #fff0f5;
      padding-left: 5.5px;
    }
    // When the .vti__input (a sibling, but before this element in the template) is not focused.
    // Right border as a divider between country select and phone input when number is invalid.
    .vti__dropdown:has(~ .vti__input:not(:focus, .vti__search_box)) {
      border-right: 1.5px solid #e32636 !important;
    }

    .vti__dropdownIcon {
      fill: #e32636;
    }
  }

  &.is-danger:has(.vti__search_box:focus) {
    background-color: #fff0f5;
    border: 1px solid #e32636 !important;
    box-shadow: 0 0 0 1px #e32636 !important;
  }

  border-width: 1px;
  height: 45px !important;
  padding: 0 !important;
}

.VueTelInput:focus-within {
  border-radius: 8px;
  border: 1px solid #0f62f4 !important;
  box-shadow: 0 0 0 1px #0f62f4 !important;
  .vti__dropdownIcon {
    fill: #1064F4;
  }
}

.label-title {
  display: block;
}

// We are unable to use existing classes on dropdown element, hence defining styles for it
.sd {
  .VueTelInput {
    .vti__dropdownIcon {
      fill: #EC008C;
      &:hover {
        fill: #363636;
      }
    }
    &:focus-within {
      border: 1px solid #80BE3E !important;
      box-shadow: 0 0 0 1px #80BE3E !important;
      .vti__dropdownIcon {
        fill: #EC008C;
      }
    }
    .vti__dropdown:focus {
      border: 1px solid #80BE3E;
      box-shadow: 0 0 0 1px #80BE3E;
    }
    &.is-danger {
      .vti__dropdownIcon:not(:focus-within) {
        fill: #e32636;
      }
    }
  }
}
.asda {
  .VueTelInput {
    .vti__dropdownIcon {
      fill: #0073B1;
      &:hover {
        fill: #363636;
      }
    }
    &:focus-within {
      border: 1px solid #68A51C !important;
      box-shadow: 0 0 0 1px #68A51C !important;
      .vti__dropdownIcon {
        fill: #0073B1;
      }
    }
    .vti__dropdown:focus {
      border: 1px solid #68A51C;
      box-shadow: 0 0 0 1px #68A51C;
    }
    &.is-danger:not(:focus-within) {
      .vti__dropdownIcon {
        fill: #e32636;
      }
    }
  }
}
</style>
